const images = () => {
    
    let popupWrap = document.querySelector('.popup-wrap'),
        imgPopup = document.querySelector('.popup-wrap .img-popup .content'),
        close = document.querySelector('.close'),
        thumbnail = document.querySelectorAll('.thumbnail'),
        title = document.querySelector('.popup-wrap .title'), 
        descr = document.querySelector('.popup-wrap .descr');


    function getCSRFToken() {
        let meta = document.getElementsByTagName('meta');
        let csrf;
        for (let i = 0; i < meta.length; i++) {
            if(meta[i].getAttribute('name') == 'csrf-token') {
                csrf = meta[i].getAttribute('content');
            }
        }
        return csrf;
    }

    let csrfToken = getCSRFToken();

    if (popupWrap) {

        let scroll = calcScroll();

        thumbnail.forEach(function (item, key) {
            item.addEventListener('click', callModal);
        });   
        close.addEventListener('click', () => {
            popupWrap.classList.add('hide');    
            document.body.style.overflow = "";  
            document.body.style.marginRight = `0px`;
            removeTagFromContent();                      
        });

        popupWrap.addEventListener('click', (e) => {
            if (e.target === popupWrap) {
                popupWrap.classList.add('hide');                 
                document.body.style.overflow = ""; 
                document.body.style.marginRight = `0px`;
                removeTagFromContent();                                                       
            }
        });
        
        function removeTagFromContent() {
            if(document.querySelector('.img-popup .content img')) {
                document.querySelector('.img-popup .content img').remove();
            }

            if(document.querySelector('.img-popup .content .youtube-link-popup')) {
                document.querySelector('.img-popup .content .youtube-link-popup').remove();
            }
        }

        //функция расчета ширины полосы скрола, нужна чтобы экран не прыгал при открытии модалки
        function calcScroll() {
            let div = document.createElement('div');

            div.style.width = '50px';
            div.style.height = '50px';
            div.style.overflow = 'scroll';
            div.style.visibility = 'hidden';

            document.body.appendChild(div);
            let scrollWidth = div.offsetWidth - div.clientWidth;
            div.remove();

            return scrollWidth;
        }

        function callModal(evt) {            

            let item = evt.target;

            dataFetch(item.getAttribute("data-id"));

            popupWrap.classList.remove('hide');
            popupWrap.style.animation = 'fadeIn 0.5s';
            document.body.style.overflow = "hidden"; // чтобы фон за модальным окном  не скролился
            document.body.style.marginRight = `${scroll}px`; // чтобы экран не прыгал при закрытии модалки из-за скрола

            let dataTitle = item.getAttribute("data-title");
            let dataDescription = item.getAttribute("data-description");
            let dataYear = item.getAttribute("data-year");
            let dataHeight = item.getAttribute("data-height");
            let dataWidth = item.getAttribute("data-width");
            title.textContent = dataTitle;           
            descr.textContent = dataDescription ? `${dataDescription}` : '';            
        }

        function dataFetch(work_id) {
            let formData = new FormData();
            formData.append('work_id', work_id);
            let url = '/ajax/works/img-request';
            fetch(url, {
                method: "POST",
                body: formData,
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            }).then( response => {
                return response.json();
            }).then( data => {
                checkVideo(data);
            }).catch( e => {
                console.log(e);
            });
        }

        function checkVideo(data) {            
            
            if(data.img) {

                let img = document.createElement('img');
                img.src = `/img/works/${data.img}`;  
                img.classList.add('img');
                imgPopup.append(img);

            }

            if(data.video) {
                let a = document.createElement('a');
                a.href = `${data.video}`;               
                a.classList.add('youtube-link-popup'); 
                a.setAttribute('target', 'blanck');                              
                let youtubeImg = document.createElement('img');
                youtubeImg.src = "/img/youtube.svg";
                youtubeImg.classList.add('youtube-img-popup');
                a.append(youtubeImg);
                imgPopup.append(a);
            }
        }
    }
}
export default images;